import { render, staticRenderFns } from "./UpgradeToEmailConnection.vue?vue&type=template&id=47db81df&scoped=true&lang=pug"
import script from "./UpgradeToEmailConnection.vue?vue&type=script&lang=js"
export * from "./UpgradeToEmailConnection.vue?vue&type=script&lang=js"
import style0 from "./UpgradeToEmailConnection.vue?vue&type=style&index=0&id=47db81df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47db81df",
  null
  
)

export default component.exports